import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { BodyText, LabelText } from '../../../../../Text';
import { NAVBAR_FLOATING_ACTION_SIZE } from '../../../../Navbar.constants';
import { NavbarGlassView } from '../NavbarGlassView/NavbarGlassView';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingGroupOrderHostIndicator = (props: Props) => {
  const { eyebrow, shadow, title } = props;

  return (
    <NavbarGlassView shadow={shadow} style={styles.container}>
      <View style={styles.titleContainer}>
        <LabelText
          maxFontSizeMultiplier={1.2}
          numberOfLines={1}
          sizeMatch={['10']}
          style={styles.eyebrow}
        >
          {eyebrow}
        </LabelText>

        <BodyText
          maxFontSizeMultiplier={1.2}
          numberOfLines={1}
          sizeMatch={['16']}
          style={styles.title}
        >
          {title}
        </BodyText>
      </View>
    </NavbarGlassView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexShrink: 1,
    minWidth: 0,
    maxWidth: 400,
    height: NAVBAR_FLOATING_ACTION_SIZE,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing['1'],
    paddingHorizontal: theme.spacing['6'],
  },
  titleContainer: {
    flexShrink: 1,
    alignItems: 'flex-end',
    minWidth: 0,
    maxWidth: '100%',
  },
  eyebrow: {
    color: theme.colors.OPACITY.DARK_KALE.DARK,
    textAlign: 'right',
    textTransform: 'uppercase',
  },
  title: {
    flexShrink: 1,
    minWidth: 0,
    color: theme.colors.CHARCOAL,
    textAlign: 'right',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  eyebrow: string;
  shadow?: boolean;
  title: string;
};
